<template>
  <div
    v-if="existingCompanyLinks.length"
    class="sf-tab"
    data-walkthrough-id="company-links-overview"
    data-testid="company-links-overview"
  >
    <div
      v-for="companyLink in existingCompanyLinks"
      :key="companyLink.id"
      data-testid="existing-company-link"
    >
      <div class="sf-tab-item sf-level-between sf-level sf-pad-h-2">
        <ExternalCompanyLabel
          :company-id="companyLink.sourceCompanyId"
          :company-name="companyLink.sourceCompanyName"
          :created-by="companyLink.createdBy"
          :created-at="companyLink.createdAt"
        />
        <div class="sf-level-item">
          <SfButton
            :small="true"
            variant=""
            class="tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center"
            :data-testid="'delete_' + companyLink.id"
            @click="onDeleteCompanyLink(companyLink)"
          >
            <span class="fa fa-regular fa-trash-can"></span>
          </SfButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ExistingCompanyLink } from '../types'

import ExternalCompanyLabel from '@app/application/company_links/components/external-company-label.vue'

import { storeToRefs } from 'pinia'
import { useCompanyLinksStore } from '@app/application/company_links/store/use-company-links'
import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'

interface Props {
  modalMode: boolean
}
const { modalMode } = defineProps<Props>()

const companyLinksStore = useCompanyLinksStore()

if (!modalMode) {
  companyLinksStore.initExistingCompanyLinks()
}

const { existingCompanyLinks } = storeToRefs(companyLinksStore)

function onDeleteCompanyLink(companyLink: ExistingCompanyLink): void {
  companyLinksStore.markLinkForDeletion(companyLink)
}
</script>
